import axios from 'axios';

import type { ClauseLibrary } from '../../@types/types';
import { getRequestAuth } from '../helpers/getRequestAuth';

export const fetchClauseLibrary = async (authToken: string): Promise<ClauseLibrary> => {
  const auth = await getRequestAuth(authToken);

  const response = await axios({
    method: 'get',
    url: `${process.env.REACT_APP_API_URL}/clauses${auth.authProvider === 'al' ? '-spa-al' : ''}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth.token,
    },
  });

  return response.data;
};
